import styled from 'styled-components';

import Link from 'components/link';

export const Container = styled.div`
  padding: 1.5rem 1rem;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.token('border-color-default')};
  border-radius: 0.25rem;
`;
export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;
export const Text = styled.p`
  margin: 0;
  font-weight: 600;
`;
export const Description = styled.div`
  border-top: 1px solid ${p => p.theme.token('border-color-default')};
  padding-top: 1rem;
`;
export const StyledLink = styled(Link)`
  text-decoration: underline;
`;
export const ToggleContainer = styled.div``;
